let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fC988")).then(() => parcelRequire('lsQoH'));